import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],

});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllSocieteConnectedPersonne(cxt) {
        let data = await client.get('dirigeant/personne/connectee');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP(cxt) {
        let data = await client.get('dirigeant');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) {
        let data = await client.get('dirigeant/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('dirigeant/edit/' + payload.id, payload) : await client.post('dirigeant/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('dirigeant/'+ id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async getDirigeantsBySociete(cxt, societeId) {
        let data = await client.get(`societe/${societeId}/dirigeants/all`);
        return data;
    },
    async activate(cxt, id) {
        let { data } = await client.put(`/dirigeant/activate/${id}`);
        return data;
    },
    async deactivate(cxt, id) {
        let { data } = await client.put(`/dirigeant/deactivate/${id}`);
        return data;
    },
    async grantPrivileges(cxt, id) {
        let { data } = await client.put(`dirigeant/grant-privileges/${id}`);
        return data;
    },
    async revokePrivileges(cxt, id) {
        let { data } = await client.put(`dirigeant/revoke-privileges/${id}`);
        return data;
    },
    async checkHasPrivileges(cxt, id) {
        let { data } = await client.get(`dirigeant/${id}/has-privileges`);
        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
